import { MessageBar, MessageBarType, Spinner, Stack } from "@fluentui/react";
import { useCallback, useEffect, useState } from "react";

import LogRow from "./LogRow";
import { ITermLogs } from "./TermLogs.interfaces";

import { useApi } from "@/core/libs/api/react-query/useApi";

interface TermLogsProps {
  termId: number;
}

function TermLogs({ termId }: TermLogsProps) {
  const [termLogs, setTermLogs] = useState<ITermLogs[]>([]);
  const [isLoadingTermLogs, setIsLoadingTermLogs] = useState<boolean>(false);
  const [messageBarProps, setMessageBarProps] = useState<{
    message: string;
    type: MessageBarType;
  }>({
    message: "Não há histórico para este termo",
    type: MessageBarType.info
  });
  const { execute } = useApi();

  const getTermLogs = useCallback(
    async (id: number) => {
      setIsLoadingTermLogs(true);

      const response = await execute<ITermLogs[]>({ url: `term-logs/${id}` });

      if (!response.response.ok) {
        setMessageBarProps({
          message: "Houve um erro ao buscar o histórico deste termo.",
          type: MessageBarType.error
        });
      } else {
        setTermLogs(response.data);
      }

      setIsLoadingTermLogs(false);
    },
    [execute]
  );

  useEffect(() => {
    void getTermLogs(termId);
  }, [termId, getTermLogs]);

  const RenderTermLog = () => {
    if (isLoadingTermLogs) {
      return <Spinner label="Carregando histórico do termo.." />;
    }

    if (!termLogs?.length) {
      return (
        <MessageBar messageBarType={messageBarProps.type}>
          {messageBarProps.message}
        </MessageBar>
      );
    }

    return termLogs.map(log => <LogRow key={log.id} log={log} />);
  };

  return <Stack styles={{ root: { padding: 16 } }}>{RenderTermLog()}</Stack>;
}

export default TermLogs;
